import { DataBean } from "../DataBean";

export class SalesContact extends DataBean {


    public async getSalesContactConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesContactConstants_Number", [args]);
    }


}